// src/components/Navbar.js - Billion Dollar Premium Navbar

import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import logo from "../assets/logo.png";

const AppNavbar = ({ handleShowModal }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const paypalLink =
    "https://www.paypal.com/donate/?hosted_button_id=JWCTWZHY89WV2";

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const onMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("mousemove", onMouseMove);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const navItems = [
    { path: "/", label: "Home", icon: "fas fa-home" },
    { path: "/about", label: "About", icon: "fas fa-heart" },
    { path: "/what-we-do", label: "Our Work", icon: "fas fa-paw" },
    { path: "/team", label: "Team", icon: "fas fa-users" },
    { path: "/care-map", label: "Care Map", icon: "fas fa-map-marked-alt" },
    { path: "/contact", label: "Contact", icon: "fas fa-envelope" },
  ];

  return (
    <>
      {/* Floating Navigation */}
      <nav
        className={`billion-navbar ${scrolled ? "billion-navbar--scrolled" : ""}`}
      >
        {/* Background Effects */}
        <div className="navbar-background">
          <div className="navbar-gradient"></div>
          <div className="navbar-blur"></div>
          <div
            className="navbar-cursor-glow"
            style={{
              transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
            }}
          ></div>
        </div>

        <Container className="navbar-container">
          {/* Premium Logo Section */}
          <Link
            to="/"
            className="navbar-brand-premium"
            onClick={closeMobileMenu}
          >
            <div className="brand-container">
              <div className="brand-glow"></div>
              <img
                src={logo}
                alt="Aussie Wildlife Limited"
                className="brand-logo"
              />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="navbar-nav-desktop">
            <div className="nav-links-container">
              {navItems.map((item, index) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className="nav-link-premium"
                  style={{ "--index": index }}
                  onClick={closeMobileMenu}
                  end={item.path === "/"}
                >
                  <div className="nav-link-content">
                    <i className={item.icon}></i>
                    <span>{item.label}</span>
                  </div>
                  <div className="nav-link-bg"></div>
                  <div className="nav-link-glow"></div>
                </NavLink>
              ))}
            </div>

            {/* Premium CTA Buttons */}
            <div className="navbar-actions">
              <a
                href={paypalLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-premium btn-donate"
              >
                <i className="fas fa-heart"></i>
                <span>Donate</span>
                <div className="btn-shine"></div>
              </a>
            </div>
          </div>

          {/* Premium Mobile Menu Toggle */}
          <button
            className={`mobile-menu-toggle ${mobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            <div className="hamburger-container">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
            <div className="toggle-glow"></div>
          </button>
        </Container>
      </nav>

      {/* Simple Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${mobileMenuOpen ? "active" : ""}`}>
        <button className="mobile-menu-close" onClick={closeMobileMenu}>
          <i className="fas fa-times"></i>
        </button>

        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="mobile-nav-link"
            onClick={closeMobileMenu}
            end={item.path === "/"}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
          </NavLink>
        ))}

        <a
          href={paypalLink}
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-btn-donate"
          onClick={closeMobileMenu}
        >
          <i className="fas fa-heart"></i>
          <span>Donate</span>
        </a>
      </div>
    </>
  );
};

export default AppNavbar;
